import React, { useEffect, useContext, useState } from "react";
import "../../css/MyProjects.css";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import config from "../../config/config";
import ConfirmationModal from "../modals/ConfirmationModal";
import { useNavigate } from "react-router-dom";

const MyProjects = () => {
  const { user } = useContext(AppContext);
  const [projectData, setProjectData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [msgTitle, setMsgTitle] = useState("");
  const [message, setMessage] = useState("");
  const [icon, setIcon] = useState("");
  const [theme, setTheme] = useState("");
  const [button, setButton] = useState("");
  const [onConfirm, setOnConfirm] = useState(null);
  const token = config.getAuthToken();
  const navigate = useNavigate();

  const handleProjectEdit = (projectId) => {
    if (!projectId) return;
    navigate(`/myProject/${projectId}`);
  };

  const fetchProjectData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/getMyProjects`,
        { user_id: user?.data?.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status) {
        setProjectData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setShowModal(true);
      setMsgTitle("Failed to fetch project data. Please try again.");
      setMessage("");
      setIcon("fa fa-times-circle-o");
      setTheme("red");
      setButton("ok");
    }
    setIsLoading(false);
  };

  const deleteListing = async (projectId, userId, token) => {
    try {
      if (projectId && userId) {
        const formData = new FormData();
        formData.append("user_id", userId);

        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/deleteProject/${projectId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.status) {
          setProjectData((prevData) =>
            prevData.filter((item) => item.id !== projectId)
          );
        } else {
          console.error("Failed to delete project:", response.data.message);
        }
      }
    } catch (error) {
      console.error("Delete API Error:", error);
    }
  };

  const handleDeleteProject = (project, user, token) => {
    setShowModal(true);
    setMsgTitle("Are you sure you want to delete Property data?");
    setMessage();
    setIcon("fa fa-info-circle");
    setTheme("gold");
    setButton("yes");
    setOnConfirm(() => () => {
      deleteListing(project?.id, user?.data?.id, token);
      setShowModal(false); // close modal after deletion
    });
  };

  useEffect(() => {
    if (user?.data?.id) {
      fetchProjectData();
    }
  }, [user?.data?.id]);

  return (
    <div>
      <div className="d-flex justify-content-between">
        <div className="title-header breadcrumb">
          <div className="profile-path">
            <span>My Projects</span>
          </div>
        </div>
      </div>

      <div className="d-flex flex-column" style={{ width: "100%" }}>
        {isLoading ? (
          <p className="text-center">Loading projects...</p>
        ) : projectData && projectData.length > 0 ? (
          projectData.map((project, index) => (
            <>
              <table key={index} class="table probildbx">
                <thead>
                  <tr className="bildrbx">
                    <th colspan="2" scope="col" className="bildrnam">
                      {project.name || "Unnamed Listing"}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="w-50" scope="row">
                      Category
                    </th>
                    <td className="w-50">{project.category || "N/A"}</td>
                  </tr>
                  <tr>
                    <th scope="row">Developer</th>
                    <td>{project.developer_name || "N/A"}</td>
                  </tr>
                  <tr>
                    <th scope="row">City</th>
                    <td>{project.city_name || "N/A"}</td>
                  </tr>
                  <tr>
                    <th scope="row">Location</th>
                    <td>
                      {project.sub_location_name || "N/A"},{" "}
                      {project.location_name || "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Area</th>
                    <td>
                      {project.area
                        ? `${project.area} ${
                            project.area_unit_name
                              ? project.area_unit_name
                              : "N/A"
                          }`
                        : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Launch Date</th>
                    <td>{project.launch_date || "N/A"}</td>
                  </tr>
                  <tr>
                    <th scope="row">RERA ID</th>
                    <td>{project.rera_id || "N/A"}</td>
                  </tr>
                  <tr>
                    <th scope="row">Verified</th>
                    <td>{project.isVerified === 1 ? "Yes" : "No"}</td>
                  </tr>
                  <tr>
                    <th scope="row">Description</th>
                    <td>
                      {project.description || "No description available."}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Status</th>
                    <td>
                      <p
                        className={
                          project.status === 1
                            ? "bg-success text-white p-2 rounded statusbx"
                            : "bg-danger text-white p-2 rounded statusbx"
                        }
                      >
                        {project.status === 1 ? "Active" : "Inactive"}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Action</th>
                    <td>
                      <button
                        className="btn blubtn"
                        onClick={() => handleProjectEdit(project?.id)}
                      >
                        Edit
                      </button>{" "}
                      &nbsp;
                      <button
                        className="btn orngbtn"
                        onClick={() =>
                          handleDeleteProject(project, user, token)
                        }
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          ))
        ) : (
          <p>No listings found.</p>
        )}
      </div>
      {/* </div> */}
      {showModal && (
        <ConfirmationModal
          onClose={() => setShowModal(false)}
          title={msgTitle}
          message={message}
          icon={icon}
          theme={theme}
          button={button}
          onConfirm={onConfirm}
        />
      )}
    </div>
  );
};

export default MyProjects;
